import { Box, Button, CircularProgress, Table, TableCell, TableHead, TableRow, Typography } from '@mui/material'
import { useAsyncEffect } from '@xylabs/sdk-react'
import { XyoWorldMinterEvents } from '@xyo-network/world-typechain'
import { useContext, useState } from 'react'

import { MinterAuctionContext } from '../../../Contexts'
import HistoryTableBody from './Body'

interface BidHistoryTableProps {
  events?: XyoWorldMinterEvents.BidPlaced[]
  header?: boolean
  page?: number
  pageSize?: number
  reverseOrder?: boolean
}

const BidHistoryTable: React.FC<BidHistoryTableProps> = (props) => {
  const { pageSize, reverseOrder = false, header = true } = props
  const [events, setEvents] = useState(props.events)
  const { auction } = useContext(MinterAuctionContext)

  useAsyncEffect(
    // eslint-disable-next-line react-hooks/exhaustive-deps
    async (isMounted) => {
      const events = await auction?.events().bidPlaced()
      if (!isMounted()) return
      setEvents(events)
    },
    [auction],
  )

  const [page, setPage] = useState(props.page ?? 0)
  if (events === undefined) {
    return (
      <Box display="flex" flexGrow={1} justifyContent="center">
        <CircularProgress size={24} />
      </Box>
    )
  }
  return (
    <Box display="flex" flexDirection="column" flexGrow={1}>
      <Table>
        <TableHead style={{ display: header ? 'table-header-group' : 'none' }}>
          <TableRow>
            <TableCell align="center" padding="none">
              <Box display="flex" justifyContent="center" paddingBottom={0.5}>
                <Typography variant="caption">Block</Typography>
              </Box>
            </TableCell>
            <TableCell align="center" padding="none">
              <Box display="flex" justifyContent="center" paddingBottom={0.5}>
                <Typography variant="caption">Bidder</Typography>
              </Box>
            </TableCell>
            <TableCell align="center" padding="none">
              <Box display="flex" justifyContent="center" paddingBottom={0.5}>
                <Typography variant="caption">Amount</Typography>
              </Box>
            </TableCell>
          </TableRow>
        </TableHead>
        <HistoryTableBody events={events} page={page} pageSize={pageSize} reverseOrder={reverseOrder} />
      </Table>
      {pageSize ? (
        <Box display="flex" flexGrow={1} justifyContent="center" paddingTop={1}>
          <Box paddingX={0.5}>
            <Button disabled={page === 0} onClick={() => setPage(page - 1)}>
              Prev
            </Button>
          </Box>
          <Box paddingX={0.5}>
            <Button disabled={(page + 1) * pageSize >= events.length} onClick={() => setPage(page + 1)}>
              Next
            </Button>
          </Box>
        </Box>
      ) : null}
    </Box>
  )
}

export default BidHistoryTable
